<template>
  <div>
    <div class="animate__animated animate__fadeIn" v-if="!cadastro">
      <div class="row d-flex justify-content-between">
        <div class="col-md-auto">
          <h4 class="font-weight-bold">Composição Familiar</h4>
        </div>
        <div class="col-md-auto">
          <button
            class="btn btn-sm btn-sm btn-primary"
            @click="cadastro = true"
          >
            <i class="fas fa-plus-square" />
            {{ $t("Cadastrar") }}
          </button>
          <button
            class="btn btn-sm btn-sm btn-secondary"
            v-if="item.familiares_ativos.length > 0"
            @click="abrirModalOrganizarMembros"
          >
            <i class="mdi mdi-sort"></i>
            {{ $t("Organizar composição familiar") }}
          </button>
          <button
            class="btn btn-sm btn-sm btn-warning"
            v-if="item.familiares_ativos.length > 0"
            @click="abrirModalRemanejar"
          >
            <i class="fas fa-exchange-alt"></i>
            {{ $t("Trocar responsável familiar") }}
          </button>
          <button
            class="btn btn-sm btn-sm btn-info"
            v-if="item.familiares_ativos.length > 0 && habilitar_transferencia"
            @click="abrirModalTransferir"
          >
            <i class="fas fa-share-square"></i>
            {{ $t("Transferir pessoas") }}
          </button>
        </div>
      </div>
      <div class="row mx-1">
        <div
          v-if="!habilitar_transferencia"
          class="alert alert-warning col-12 py-1 d-flex align-items-center"
        >
          <i class="mdi mdi-24px mdi-alert-decagram"></i>
          {{ $t("Não possui pessoas aptas para transferência.") }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-tabs content-class="mt-3">
            <b-tab title="Familiares" active>
              <div class="row mt-3 mb-3">
                <div class="col-md-12">
                  <table
                    v-if="item.familiares.length > 0"
                    class="b-table table table-striped b-table-stacked-md"
                  >
                    <thead>
                      <tr>
                        <span>
                          <a
                            v-if="!showName"
                            @click.prevent="mostrarNome"
                            href="#"
                            ><i class="fas fa-eye"></i> Mostrar Nome de
                            Registro</a
                          >
                          <a v-else @click.prevent="ocultarNome" href="#"
                            ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                            Registro</a
                          >
                        </span>
                      </tr>
                      <tr>
                        <th>Usuário</th>
                        <!-- <th>Posição Familiar</th> -->
                        <th>Pendências</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="familiar in item.familiares"
                        :key="familiar.id"
                        :style="
                          familiar.emsituacao &&
                          familiar.emsituacao.status &&
                          familiar.emsituacao.status == '1'
                            ? 'background:#fff5d6'
                            : ''
                        "
                      >
                        <td>
                          <table class="col-12">
                            <tbody>
                              <tr
                                v-if="
                                  familiar.emsituacao &&
                                  familiar.emsituacao.status &&
                                  familiar.emsituacao.status == '1'
                                "
                                style="background: #fff5d6"
                              >
                                <td class="py-0 border-0" colspan="2">
                                  <h4 class="col-12 px-0">
                                    <b-icon
                                      icon="exclamation-triangle-fill"
                                      variant="warning"
                                      animation="fade"
                                    ></b-icon>
                                    PESSOA EM SITUAÇÃO DE RUA
                                  </h4>
                                </td>
                              </tr>
                              <tr>
                                <td class="bg-white py-0 border-0">
                                  <b v-if="familiar.codigo_usuario_cadunico">
                                    CAD:
                                  </b>
                                  <b v-else>ID:</b>
                                </td>
                                <td class="bg-white py-0 border-0">
                                  <span v-if="familiar.codigo_usuario_cadunico">
                                    {{ familiar.codigo_usuario_cadunico }}
                                  </span>
                                  <span v-else>{{ familiar.id }} </span>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-white py-0 border-0">
                                  NOME COMPLETO:
                                </th>
                                <th class="bg-white py-0 border-0">
                                  <span v-if="!familiar.nome_social">{{
                                    familiar.nome_completo
                                  }}</span>
                                  <span v-else
                                    >{{ familiar.nome_social }} ( N.R.: )
                                    <span v-if="showName">{{
                                      familiar.nome_completo
                                    }}</span>
                                  </span>
                                </th>
                              </tr>
                              <tr v-if="familiar.documento">
                                <th
                                  class="bg-white py-0 border-0"
                                  :colspan="familiar.documento.nis ? '' : '2'"
                                >
                                  <span v-if="familiar.documento.nis">
                                    NIS:
                                  </span>
                                  <span v-else>
                                    <b-link
                                      href="#"
                                      v-b-tooltip.hover
                                      title="Não sabe o número do NIS ou não foi inserido no cadastro!"
                                    >
                                      NIS:
                                      <b-icon
                                        icon="exclamation-triangle-fill"
                                        variant="warning"
                                        animation="fade"
                                      ></b-icon>
                                    </b-link>
                                  </span>
                                </th>
                                <td
                                  class="bg-white py-0 border-0"
                                  v-if="familiar.documento.nis"
                                >
                                  <span>
                                    {{ familiar.documento.nis }}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-white py-0 border-0">SEXO:</th>
                                <td class="bg-white py-0 border-0">
                                  <span v-if="familiar.sexo == 1">
                                    MASCULINO
                                  </span>
                                  <span v-if="familiar.sexo == 2">
                                    FEMININO
                                  </span>
                                  <span
                                    v-if="
                                      familiar.sexo != 1 && familiar.sexo != 2
                                    "
                                  >
                                    INTERSEXO
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-white py-0 border-0">IDADE:</th>
                                <td class="bg-white py-0 border-0">
                                  {{ familiar.idade }}
                                  ano(s)
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-white py-0 border-0">STATUS:</th>
                                <td class="bg-white py-0 border-0">
                                  <span
                                    v-html="
                                      getEstadoCadastral(
                                        parseInt(
                                          familiar.estado_cadastral_cadunico
                                        )
                                      )
                                    "
                                  ></span>
                                </td>
                              </tr>
                              <tr>
                                <th class="bg-white py-0 border-0">POSIÇÃO:</th>
                                <td class="bg-white py-0 border-0">
                                  <span
                                    v-for="posicao in item.configs
                                      .posicao_familiar"
                                    :key="posicao.key"
                                  >
                                    <span
                                      v-if="
                                        posicao.key == familiar.posicao_familiar
                                      "
                                    >
                                      {{ posicao.value }}
                                    </span>
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td class="bg-white py-0 border-0" colspan="2">
                                  <span v-if="familiar.usuario_origem_id">
                                    <a
                                      class="btn btn-default btn-xs"
                                      :href="
                                        '/dashboard/usuario/edit/' +
                                        familiar.usuario_origem_id
                                      "
                                      target="_blank"
                                    >
                                      <b>Prontuário Antigo</b>
                                      <i class="fas fa-external-link-alt"></i>
                                    </a>
                                  </span>
                                  <span v-if="familiar.usuario_destino_id">
                                    <a
                                      class="btn btn-default btn-xs"
                                      :href="
                                        '/dashboard/usuario/edit/' +
                                        familiar.usuario_destino_id
                                      "
                                      target="_blank"
                                    >
                                      <b>Prontuário Novo</b>
                                      <i class="fas fa-external-link-alt"></i>
                                    </a>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="text-center">
                          <div
                            style="position: relative; width: 75px"
                            v-if="familiar.count_pendencias"
                          >
                            <b-spinner
                              class="spiner-counter"
                              variant="danger"
                              type="grow"
                              small
                            ></b-spinner>

                            <b-button
                              :title="$t('Pendências')"
                              @click="
                                abrirModal(
                                  familiar.pendencias,
                                  familiar.nome_completo
                                )
                              "
                              class="px-2 mb-0"
                              size="xs"
                              type="button"
                              v-b-tooltip.hover
                              :variant="
                                familiar.count_pendencias ? 'warning' : 'ligth'
                              "
                            >
                              <b-icon icon="exclamation-triangle-fill"></b-icon>
                              <span>
                                {{ familiar.count_pendencias }}
                              </span>
                            </b-button>
                          </div>
                          <div class="text-secondary" v-else>
                            <b-icon icon="exclamation-triangle-fill"></b-icon>
                          </div>
                        </td>
                        <td class="text-center">
                          <button
                            v-if="
                              parseInt(familiar.estado_cadastral_cadunico) !=
                                7 &&
                              parseInt(familiar.estado_cadastral_cadunico) != 4
                            "
                            class="btn px-2 mb-0 btn-danger btn-xs"
                            title="Excluir pessoa"
                            @click="
                              excluir();
                              pessoa = familiar;
                            "
                          >
                            <i class="mdi mdi-close"></i>
                          </button>
                          <b-button
                            :title="$t('Acessar Prontuário do Usuário')"
                            :to="'/dashboard/usuario/edit/' + familiar.id"
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            v-b-tooltip.hover
                            variant="primary"
                            target="_blank"
                          >
                            <i class="fas fa-external-link-square-alt"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </b-tab>
            <b-tab title="Faixa etária">
              <div class="row mt-3 pt-10">
                <div class="col-md-12">
                  <p class="d-block text-muted small mt-4 mb-4">
                    Esta seção não contabiliza familiares com estado cadastral
                    EXCLUÍDO
                  </p>
                  <table class="table table-striped table-condensed">
                    <thead>
                      <tr>
                        <th>Perfil Etário do Grupo familiar</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="perfil in $root.arrays.perfil_etario"
                        :key="perfil.id"
                      >
                        <td>{{ perfil.value }}</td>
                        <td>
                          <span
                            v-for="familiar in item.familiares_ativos"
                            :key="familiar.id"
                          >
                            <span v-if="familiar.perfil_etario == perfil.id"
                              ><i class="fas fa-user"></i>
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total de Pessoas na Família</th>
                        <th>
                          {{ item.familiares_ativos.length }}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <ModalPendenciasUsuario :pendencias="pendencias" :pessoa="pessoa" />
    </div>
    <div v-else>
      <div class="row animate__animated animate__fadeIn">
        <div class="col-md-9">
          <h4 class="font-weight-bold">Cadastrar usuário</h4>
        </div>
        <div class="col-md-3 text-right">
          <button
            class="btn active btn-outline-secondary btn-sm"
            @click="cadastro = false"
          >
            <i class="mdi mdi-arrow-left" />
            {{ $t("Voltar") }}
          </button>
        </div>
        <div class="col-md-12">
          <CadastrarPessoa :familia="item" @voltar="cadastro = false" />
        </div>
      </div>
    </div>
    <ModalTransferir
      :familia="item"
      :pessoa="pessoa"
      @atualizar="$emit('atualizar')"
    />
    <ModalRemanejar
      :familia="item"
      :pessoa="pessoa"
      @atualizar="$emit('atualizar')"
    />
    <ModalOrganizar
      :familia="item"
      :pessoa="pessoa"
      @atualizar="$emit('atualizar')"
    />
    <excluir-usuario :item="pessoa" @reload="$emit('atualizar')" />
  </div>
</template>
<script>
import CadastrarPessoa from "./composicao/Cadastrar";
import ModalTransferir from "./composicao/ModalTransferir";
import ModalRemanejar from "./composicao/ModalRemanejar";
import ModalOrganizar from "./composicao/ModalOrganizar";
import ModalPendenciasUsuario from "./composicao/ModalPendenciasUsuario";
export default {
  props: ["item"],
  name: "ComposicaoFamiliar",
  components: {
    ModalPendenciasUsuario,
    ModalTransferir,
    ModalRemanejar,
    ModalOrganizar,
    CadastrarPessoa,
  },
  data() {
    return {
      showName: false,
      cadastro: false,
      pendencias: null,
      pessoa: null,
      habilitar_transferencia: true,
    };
  },
  mounted() {
    let familiares_ativos = this.item.familiares_ativos.filter(
      (elem) =>
        (parseInt(elem.posicao_familiar) > 1 &&
          parseInt(elem.estado_cadastral_cadunico) == 3) ||
        parseInt(elem.estado_cadastral_cadunico) == 1
    );
    familiares_ativos.length > 0
      ? (this.habilitar_transferencia = true)
      : (this.habilitar_transferencia = false);
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    abrirModal(pendencias, pessoa) {
      this.pendencias = pendencias;
      this.pessoa = pessoa;

      this.$bvModal.show("modal-pendencias");
    },
    abrirModalTransferir() {
      this.$bvModal.show("modal-transferir");
    },
    abrirModalOrganizarMembros() {
      this.$bvModal.show("modal-organizar");
    },
    abrirModalRemanejar() {
      this.$bvModal.show("modal-remanejar-responsavel");
    },
    getEstadoCadastral(estado) {
      switch (estado) {
        case null:
          return '<b class="text-info"><i class="mdi mdi-information-outline"></i> Inserido Manualmente</b>';
        case 1:
          return '<b class="text-info"><i class="mdi mdi-information-outline"></i> EM CADASTRAMENTO</b>';
        case 2:
          return '<b class="text-warning"><i class="mdi mdi-alert-circle-outline"></i> SEM REGISTRO CIVIL</b>';
        case 3:
          return '<b class="text-success"><i class="mdi mdi-check-circle-outline"></i> CADASTRADO</b>';
        case 4:
          return '<b class="text-danger"><i class="mdi mdi-close-circle-outline"></i> EXCLUÍDO</b>';
          break;
        case 5:
          return '<b class="text-warning"><i class="mdi mdi-alert-circle-outline"></i> AGUARDANDO NIS</b>';
          break;
        case 6:
          return '<b class="text-warning"><i class="mdi mdi-alert-circle-outline"></i> VALIDANDO NIS</b>';
          break;
        case 7:
          return '<b class="text-warning"><i class="mdi mdi-alert-circle-outline"></i> TRANSFERIDO</b>';
          break;
        default:
          return "NENHUM";
      }
    },
    excluir() {
      swal
        .fire({
          title: "Tem certeza?",
          text: "O usuário não poderá ser vinculado a nenhum serviço.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, exclua!",
          cancelButtonText: "Não",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$bvModal.show("modal-excluir-usuario");
          }
        });
    },
  },
};
</script>

<style>
.spiner-counter {
  position: absolute;
  top: 0;
  right: 10px;
  margin-top: -0.7rem;
  width: 1.2rem;
  height: 1.2rem;
}
</style>
